import React from 'react'
import { observer } from 'mobx-react-lite'

export default observer(function SurveyLink({ title, link }) {
  return (
    <div className='w-full h-full bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-lg p-4'>
      <h1 className='font-bold text-xl py-2 dark:text-white'>Survey Link</h1>
      <div className='border-t border-rb-widget-border dark:border-rb-dark-mode-lighter py-2'>
        <p className='text-lg font-bold mb-2 dark:text-white'>{title}</p>
      </div>
      <a href={link} target='_blank' rel='noopener noreferrer' className='bg-rb-green text-white text-sm font-bold px-2 py-1 rounded-md'>Visit Survey</a>
    </div>
  )
})